import { useState } from 'react'
import './Auth.scss'
import image from '../../assets/images/4.jpeg'
import FormLoader from '../../components/loader/FormLoader'
import { Link, useNavigate } from 'react-router-dom'
import { useGlobalContext } from '../../utils/Context'
import { postNo, upload } from '../../utils/Api'

function CreateAccount() {
  const navigate = useNavigate()
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)

  const renameFile = (file: any, newName: string) => {
    return new File([file], newName, { type: file.type })
  }

  function handleSubmit(data: any) {
    const director_id = renameFile(data.director_id, 'director_id')
    const business_doc = renameFile(data.business_doc, 'business_doc')
    const formData = new FormData()
    formData.append('images', director_id)
    formData.append('images', business_doc)
    setLoading(true)
    upload('business/upload', formData)
      .then((result) => {
        if (result.status === 201) {
          postNo('onboarding-requests/create', {
            ...data,
            director_id: result.director_id,
            business_doc: result.business_doc,
          })
            .then((res) => {
              if (res.status === 201) {
                notify('success', res.message)
                setLoading(false)
                window.location.replace('/login')
              } else {
                notify('error', res.message)
                setLoading(false)
              }
            })
            .catch(() => {
              setLoading(false)
            })
        } else {
          notify('error', result.message)
          setLoading(false)
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <div className='auth flex'>
      <div className='left'>
        <img
          src={image}
          alt='delivery man image'
          onClick={() => navigate('/')}
        />
      </div>
      <div className='right flex '>
        <div className='wrap'>
          <div className='top'>
            <h1>Create Account</h1>
            <p>Create an account and get started using our APIs</p>
          </div>
          <form
            onSubmit={(e: any) => {
              e.preventDefault()
              const firstname = e.target.firstname.value
              const lastname = e.target.lastname.value
              const website = e.target.website.value
              const email = e.target.email.value
              const phonenumber = e.target.phonenumber.value
              const companyName = e.target.companyName.value
              const companyDescription = e.target.companyDescription.value
              const intent = e.target.intent.value
              const business_doc = e.target.business_doc.files[0]
              const director_id = e.target.director_id.files[0]
              if (
                !firstname ||
                !lastname ||
                !website ||
                !email ||
                !phonenumber ||
                !companyName ||
                !companyDescription ||
                !intent
              ) {
                notify('warn', 'Please fill in all compulsory fields')
                return
              }

              // Handle form submission
              handleSubmit({
                firstname,
                lastname,
                website,
                email: email.toLowerCase(),
                phonenumber,
                company_name: companyName,
                company_description: companyDescription,
                intent,
                business_doc,
                director_id,
              })
            }}
          >
            <div className='card'>
              <p>
                Company Name <span className='color-red'>*</span>
              </p>
              <input type='text' name='companyName' required />
            </div>
            <div className='flex gap-16'>
              <div className='card'>
                <p>
                  Rep First Name <span className='color-red'>*</span>
                </p>
                <input type='text' name='firstname' required />
              </div>
              <div className='card'>
                <p>
                  Rep Last Name <span className='color-red'>*</span>
                </p>
                <input type='text' name='lastname' required />
              </div>
            </div>
            <div className='card'>
              <p>
                Company Email <span className='color-red'>*</span>
              </p>
              <input type='email' name='email' required />
            </div>
            <div className='flex gap-16'>
              <div className='card'>
                <p>
                  Company Phone Number <span className='color-red'>*</span>
                </p>
                <input type='tel' name='phonenumber' required />
              </div>
              <div className='card'>
                <p>
                  Website <span className='color-red'>*</span>
                </p>
                <input type='url' name='website' required />
              </div>
            </div>
            <div className='card'>
              <p>
                Company Description <span className='color-red'>*</span>
              </p>
              <textarea
                name='companyDescription'
                id=''
                rows={10}
                required
              ></textarea>
            </div>
            <div className='card'>
              <p>
                Intent <span className='color-red'>*</span>
              </p>
              <textarea name='intent' id='' rows={10} required></textarea>
            </div>
            <div className='card'>
              <p title='This is a document that shows the business is registered'>
                Business Registration Document{' '}
                <span className='color-red'>*</span>
              </p>
              <input
                type='file'
                name='business_doc'
                accept='.png,.jpg,.jpeg'
                required
              />
            </div>
            <div className='card'>
              <p title='This is a valid ID of the director of the company'>
                Valid Director ID <span className='color-red'>*</span>
              </p>
              <input
                type='file'
                name='director_id'
                accept='.png,.jpg,.jpeg'
                required
              />
            </div>
            {/* <div className='card'>
                <p>Referral code</p>
                <input type='text' name='friend' />
              </div> */}
            <div className='card btn'>
              {loading ? (
                <FormLoader position='center' />
              ) : (
                <button type='submit'>Sign Up</button>
              )}
            </div>
            <div className='card forgot '>
              <Link to='/login'>
                <p>Login</p>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default CreateAccount
